import { render, staticRenderFns } from "./Ejml.vue?vue&type=template&id=2d80eab7"
import script from "./Ejml.vue?vue&type=script&lang=js"
export * from "./Ejml.vue?vue&type=script&lang=js"
import style0 from "./Ejml.vue?vue&type=style&index=0&id=2d80eab7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports